import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import Overview from './Overview/Overview.component';
import HowItWorks from './HowItWorks/HowItWorks.component';
import Subscription from './Subscription/Subscription.component';
import FeatureStrip from './FeaturesStrip/FeaturesStrip.component';
import CustomTraining from './CustomTraining/CustomTraining.component';
import ConnectedSafetyTools from './ConnectedSafetyTools/ConnectedSafetyTools.component';
import FinalCTAC from './FinalCTA/FinalCTA.component';
import { CompanyTrainingContent } from './CompanyTraining.styles';
import Features from './Features/Features.component';
const CompanyTraining = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Company Training"
        description="Learn about Yoda Safety Services company training management, employee tracking, and available courses."
      />

      <SideContainerComponent />

      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Company Training" />
        <PageHeader
          eyebrow="Company Training"
          title="Manage Your Company's Training"
          desc="Keep track of employee training, assign courses, and ensure compliance with Yoda Safety Services company training platform."
        />
        <CompanyTrainingContent>
          <Overview />
          <FeatureStrip />
          <Features />
          <HowItWorks />
          <Subscription />
          <CustomTraining />
          <ConnectedSafetyTools />
          <FinalCTAC />
        </CompanyTrainingContent>
      </MainSection>
    </MainContentContainer>
  );
};

export default CompanyTraining;
